const singleton = Symbol();
const singletonEnforcer = Symbol();

class CoolDown {
    
    constructor (enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw new Error('Cannot construct singleton');
        }
        this.lastRequest = '';
        this.lastTimeRequest = Date.now();
        this.runningRequests = [];
        this._type = 'CoolDown';
    }

    static instance() {
        if (!this[singleton]) {
          this[singleton] = new CoolDown(singletonEnforcer);
        }
        console.log("Instance =>",this[singleton])
        return this[singleton];
    }

    registerNewRequest(uuid,requestURL){
        console.log("Register New Request",requestURL)
        this.lastRequest = requestURL;
        this.lastTimeRequest = Date.now();
        console.log("Registered ",this.lastTimeRequest)
        this.runningRequests.push({uuid,request:requestURL});
    }

    unregisterRequest(uuid){
        console.log("Unregistering ",uuid)
        var index = this.runningRequests.findIndex( request => {
            return request.uuid == uuid
        })
        console.log("Index",index)
        this.runningRequests.splice(index,1);
        
        console.log("New Registered ",this.runningRequests)
    }

    areRequestRunning(){
        console.log("Registered ",this.runningRequests.length)
        console.log("ARE RUNNING",this.runningRequests.length > 0)
        return this.runningRequests.length > 0;
    }

    canPerformRequest(requestURL){
        console.log("Previous Request",this.lastRequest)
        console.log("Current Request",requestURL)
        if(this.lastRequest == requestURL){
            var seconds = (Date.now() - this.lastTimeRequest) / 1000;
            console.log("Seconds from last request ",seconds)
            if( seconds <= 3 ){
                return false;
            } else {
                return true;
            }
        } else {
            return true
        }
    }

}

export default CoolDown;
